import React, { useState, useEffect } from 'react';
import { IconButton, Badge, Tooltip, CircularProgress } from '@mui/material';
import { NotificationsActive as NotificationsActiveIcon } from '@mui/icons-material';
import notificationService from '@/services/notificationService';

interface NotificationBadgeProps {
  onClick: () => void;
}

const NotificationBadge: React.FC<NotificationBadgeProps> = ({ onClick }) => {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCount();
    // Poll every 30 seconds for new notifications
    const interval = setInterval(loadCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadCount = async () => {
    setLoading(true);
    const { data } = await notificationService.getActionRequiredCount();
    setCount(data);
    setLoading(false);
  };

  return (
    <Tooltip title="Notifikasi">
      <IconButton
        onClick={onClick}
        sx={{
          position: 'relative',
          '& .MuiBadge-root': {
            animation: count > 0 ? 'pulse 2s infinite' : 'none',
          },
          '@keyframes pulse': {
            '0%': { opacity: 1 },
            '50%': { opacity: 0.7 },
            '100%': { opacity: 1 },
          },
        }}
      >
        <Badge
          badgeContent={loading ? '...' : count}
          color="error"
          overlap="circular"
          variant={count > 0 ? 'standard' : 'dot'}
        >
          <NotificationsActiveIcon fontSize="small" />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default NotificationBadge;
